export const DEFAULT_TREATMENT = Symbol('control');
export type DefaultTreatment = typeof DEFAULT_TREATMENT;

export interface FeatureFlagProvider {
  getTreatment(featureName: string): string | DefaultTreatment;

  onAvailable(callback: () => void): () => void;
  onReady(callback: () => void): () => void;
  onUpdate(callback: () => void): () => void;
}
